import {useRouter} from 'vue-router';
import {Ref, ref, watch} from 'vue';
import URI from 'urijs';
import _ from "lodash";

export function bindQueryParam(reactiveData: Record<string, unknown>, key: string, queryKey: string) {
    const queryParam = useQueryParam(queryKey);
    watch(queryParam, () => {
        reactiveData[key]
    }, {deep: true})
}

export function useQueryParam(key: string) {
    const data: Ref = ref({})
    const router = useRouter()
    watch(() => router.currentRoute.value.query[key], () => {
        const value = router.currentRoute.value.query[key];
        if (value !== undefined && typeof value === "string") {
            try {
                data.value = JSON.parse(value);
            } catch (e) {
                console.log(e);
            }
        } else {
            data.value = undefined;
        }
    }, {deep: true, immediate: true});
    watch(data, () => {
        const url = new URI(router.currentRoute.value.fullPath);
        url.removeQuery(key);
        if (data.value !== undefined) {
            url.addQuery(key, JSON.stringify(data.value))
        }
        router.push(url.toString());
    }, {deep: true, immediate: true});
    return data;
}

/**
 * 绑定a和b的属性
 * @param a
 * @param b
 */
export function bindRef(a: Ref<unknown>, b: Ref<unknown>) {
    watch(a, () => {
        if (!_.isEqual(a.value, b.value)) {
            b.value = a.value;
        }
    }, {deep: true, immediate: true})
    watch(b, () => {
        if (!_.isEqual(a.value, b.value)) {
            a.value = b.value;
        }
    }, {deep: true, immediate: true})
}
